import {
    putRouteStatusLoading,
    putRouteStatusRequest,
    putRouteStatusSuccess,
    putRouteStatusReject,
    putRouteStatusReset
} from "../../actions/route/putStatusRoute";

export const putRouteStatus = (formData) => async (dispatch, getState) => {
    dispatch(putRouteStatusLoading());
    try {
        const { data } = await putRouteStatusRequest(formData, getState);
        dispatch(putRouteStatusSuccess(data))
    } catch (error) {
        dispatch(putRouteStatusReject(error))
    } finally {
        setTimeout(() => { dispatch(putRouteStatusReset()) }, 3000);
    }
    return Promise.resolve();
};